// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiComponentVerificationStatusSchema = z.enum(['UNVERIFIED','CODE_ONLY','RUNTIME_VERIFIED','CONTRADICTED','FAILED','SUPPRESSED'] as const);

export type AiComponentVerificationStatusType = `${z.infer<typeof AiComponentVerificationStatusSchema>}`

export default AiComponentVerificationStatusSchema;
